import {Component} from '@angular/core';
import {CultureleGiftenComponent} from './culturele-giften/culturele-giften.component';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-aftrekbare-giften',
  templateUrl: './aftrekbare-giften.component.html',
  styleUrls: ['./aftrekbare-giften.component.scss'],
  imports: [
    CultureleGiftenComponent,
    CommonModule
  ]
})
export class AftrekbareGiftenComponent {}
